import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import ProgressLoader from 'Components/Widgets/ProgressLoader';

import { 
    
 } from 'Actions';

class FitnessItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            student:'', 
            loader:false,
            
        };
    }


render() {

    const { playerinterventionlist, loading} = this.props;
    var totinvert=0; 
    if(playerinterventionlist.length!=0){
        var totinvert=playerinterventionlist.range.total+playerinterventionlist.course.total;
    }

      return(
        <div>
                    <div className="row">
                        <button className="mr-3 mb-3 btn btn-outline-info" onClick={() =>this.props.onClick(1)}> SPORTS SCIENCE SCREENING REPORTS</button> 
                        <button className="mr-3 mb-3 btn btn-outline-info" onClick={() =>this.props.onClick(2)}> MSK COMPARATIVE ANALYSIS REPORTS </button> 
                        <button className="mr-3 mb-3 btn btn-outline-info" onClick={() =>this.props.onClick(3)}> STRENGTH & CONDITIONING COMPARATIVE ANALYSIS REPORTS </button> 
                        <button className="mr-3 mb-3 btn btn-outline-info" onClick={() =>this.props.onClick(4)}> MSK FINDING REPORTS</button> 
                        <button className="mr-3 mb-3 btn btn-outline-info" onClick={() =>this.props.onClick(5)}> INJURY REPORTS & UPDATES</button> 
                        <button className="mr-3 mb-3 btn btn-outline-info" onClick={() =>this.props.onClick(6)}> INJURY PROFILE</button>  
                        <div className="col-sm-12 col-lg-12" style={{height:"100px"}}>

                        </div>
                    </div>
                    

                    {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                    }
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention}) => {
    
    const { playerinterventionlist, loading } = playerintervention;
    return { playerinterventionlist, loading };
   
}


export default connect(mapStateToProps, {
    
})(FitnessItems);
